import React from 'react';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import metaOverrideSet from './metaOverrideSet';
import Layout from './Layout';

export const AccountDebitConfirmStepTemplate = ({ resource }) => {
  return (
    <MetaResourceRenderer
      resource={resource}
      layout={Layout}
      metaOverrideSet={metaOverrideSet}
    />
  );
};

AccountDebitConfirmStepTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
